import { cacheKeys } from "@constants/cache-keys";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { useIsMutating } from "@tanstack/react-query";
import { Dialog as PaperDialog } from "react-native-paper";
import SessionConfigContainer from "../containers/SessionConfigContainer";

type Props = {
	visible: boolean;
	handleClose?: () => void;
	selectedTagIds?: number[];
	studyRecommendedTopics?: boolean;
	preferRecommendedTab?: boolean;
	onShowPurchase: () => void;
};
export const SessionConfigDialog = ({
	visible,
	handleClose,
	selectedTagIds,
	studyRecommendedTopics,
	preferRecommendedTab,
	onShowPurchase,
}: Props) => {
	const numCreatingSession = useIsMutating({
		mutationKey: [cacheKeys.createSession],
	});
	const numResumingSession = useIsMutating({
		mutationKey: [cacheKeys.resumeSession],
	});
	const isCreatingSession = numCreatingSession > 0 || numResumingSession > 0;

	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			dismissable={!isCreatingSession}
			width="80%"
			maxWidth={640}
			minHeight={520}
			anchor="top"
		>
			<PaperDialog.Content
				style={{
					flex: 1,
					paddingBottom: 0,
					paddingHorizontal: 0,
					paddingTop: 0,
				}}
			>
				<SessionConfigContainer
					propSelectedTagIds={selectedTagIds}
					propStudyRecommendedTopics={studyRecommendedTopics}
					propPreferRecommendedTab={preferRecommendedTab}
					handleClose={handleClose}
					onShowPurchase={onShowPurchase}
					showTitle
				/>
			</PaperDialog.Content>
		</DialogWrapper>
	);
};
